export default {
  base_url: "http://localhost:5000/",
  api_base_url: "https://newscrossword.org/member-area",
  api_path: "https://newscrossword.org/member-area/api/",
};
